import { STATUS, LOCALSTATUS } from '../../config';

const { new: new_form, in_progress, submitted, report_available } = STATUS;
const { synchronized, tmp_form } = LOCALSTATUS;

export class Form {
  constructor(form = {}) {
    this.form = form;
  }

  canAccessForm(userId) {
    if (![new_form, in_progress].includes(this.status())) return true;
    return this.buyerId() === userId;
  }

  status() {
    return this.form?.status;
  }

  localStatus() {
    return this.form?.localStatus;
  }

  buyerId() {
    return this.form?.buyerId;
  }

  totals() {
    const obj = this.form?.inspection?.report?.totals;
    if (!obj) return [];
    return Object.entries(obj).map(([referential, cost]) => ({ referential, cost }));
  }

  recordKey() {
    return this.form?.inspection?.recordKey;
  }

  recordId() {
    return this.form?.recordId;
  }

  country() {
    return this.form?.country;
  }

  inspectionReport() {
    return (
      this.status() === report_available ||
      (this.status() === submitted && (this.localStatus() === synchronized || this.localStatus() === tmp_form))
    );
  }

  sendingInspectionInProgress() {
    return this.status() === submitted;
  }

  checkUpdatedAtInspection() {
    return !!this.form?.updatedAt;
  }
}
